import * as constants from "../../constants";

const reportInitState = {
  users: [],
  payload: [],
  roles: [],
  emails: [],
};

export function userManagement(state = reportInitState, action) {
  switch (action.type) {
    case constants.USER_MANAGEMENT_GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users
      }
    case constants.USER_MANAGEMENT_GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.roles
      }
    case constants.BLACKLISTED_EMAILS_GET_EMAILS_SUCCESS:
      return {
        ...state,
        emails: action.payload.blacklisted_emails
      }
    default:
      return state;
  }
}
